import { render, staticRenderFns } from "./cta-image.vue?vue&type=template&id=73768c99"
import script from "./cta-image.vue?vue&type=script&lang=js"
export * from "./cta-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CImage: require('/vercel/path0/components/ui/c-image.vue').default})
